import React, { useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Input from "../../../../../../stories/Input/Input";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import NoData from "../../../../../../images/NoData.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import {
  CustomModal,
  getModifiedScrollHeight,
} from "../../../../../../utils/UtilFunctions";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import {
  AtsAcLdgrEdge,
  AtsAcLdgrOrderField,
  GetSuppliersResult,
  GetSuppliersVars,
  LdgrQueryType,
} from "../../supplier/queries/types";
import { GetSuppliers } from "../../supplier/queries/queries";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  debouncedDelay,
  emptyMessage,
} from "../../../../../../utils/constants";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { LicenseTypes, Operation } from "../../../../../../utils/Enum.types";
import { useLazyQuery } from "@apollo/client";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { TableHeaderProps } from "../../../../../../utils/types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import EyeWhite from "../../../../../../images/EyeWhite.svg";
import AssignImage from "../../../../../../images/Assign.svg";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import Navbar from "../../../../../common/layout/Navbar";
import useLabels from "../../../../../../customHooks/useLabels";
import AssignEmps from "./AssignEmps";
import ViewEmps from "./ViewEmps";
import { useDebounce } from "../../../../../../customHooks/useDebounce";

export interface selectedSupplierType {
  supplierId: number;
  supplierDesc: string;
}

const AssociateEmps = () => {
  const navigate = useNavigate();

  const { customer_id } = useUrlParams();
  const { Masters_Table } = useAssetTableJson();

  const [associate, setAssociate] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [message, setMessage] = useState(emptyMessage);
  const [suppliers, setSuppliers] = useState<AtsAcLdgrEdge[]>([]);
  const { itemLabel, ledgerLabel } = useLabels();
  const [selectedSupplier, setSelectedSupplier] =
    useState<selectedSupplierType>({
      supplierId: 0,
      supplierDesc: "",
    });

  const [GetSupplierDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetSuppliersResult,
    GetSuppliersVars
  >(GetSuppliers);

  const dynamicHeaders: TableHeaderProps[] =
    Masters_Table.Masters.AssociationItems.ItemToSupplier.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              {params.row.empCount > 0 ? (
                <button
                  className="associate-supplier__tableblock--view"
                  onClick={() => {
                    setSelectedSupplier({
                      supplierId: params.row.supplierId,
                      supplierDesc: params.row.desc,
                    });
                    setViewModal(!viewModal);
                  }}
                >
                  View Employees <img src={EyeWhite} alt="" />
                </button>
              ) : (
                <button
                  className="associate-supplier__tableblock--assign"
                  onClick={() => {
                    setSelectedSupplier({
                      supplierId: params.row.supplierId,
                      supplierDesc: params.row.desc,
                    });
                    setAssociate(!associate);
                  }}
                >
                  Assign Employees <img src={AssignImage} alt="" />
                </button>
              )}
            </>
          );
        }

        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ASSOCIATE_TO_SUPPLIER,
      JSON.stringify(newModel)
    );
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetSuppliers.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = suppliers.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setSuppliers(updatedNewData);
        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            supplierId: node.id,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            empCount: node.empCount,
          }))
        );
      } else {
        setSuppliers(newData);
        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            supplierId: node.id,
            desc: node.desc,
            gstNo: node.supplier_details.gstNo,
            city: node.supplier_details.city,
            state: node.supplier_details.state,
            proficiency: node.supplier_details.proficiency,
            empCount: node.empCount,
          }))
        );
      }
      setEndCursor(data.GetSuppliers.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetSuppliers.edges;
              const pageInfo = fetchMoreResult.GetSuppliers.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetSuppliers.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetSuppliers: {
                  edges: [...suppliers, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetSuppliers.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable && rows.length)
      scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [rows]);

  useEffect(() => {
    const fetchData = async () => {
      try {
   
        if (customer_id) {
          GetSupplierDetails({
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsAcLdgrOrderField.CREATED_AT,
              },
            
              name: debouncedSearch,
              input: {
                query_type: LdgrQueryType.ALL,
                itemID: 0,
                tableLevel: undefined,
              },
            },
          });
        }
      } catch (err) {
        setMessage({
          flag: true,
          message: (err as Error).message,
          operation: Operation.NONE,
        });
      }
    };
    fetchData();
  }, [customer_id, GetSuppliers, debouncedSearch]);

  const handleClose = () => {
    setMessage(emptyMessage);
  };

  return (
    <>
      <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />{" "}
      <Title>Associate Employee to {ledgerLabel}</Title>
      <div className="associate-supplier">
        <div className="associate-supplier__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="associate-supplier__tableblock">
          {rows.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />

        <CustomDrawer
          anchor="right"
          open={associate}
          onClose={() => setAssociate(!associate)}
        >
          <AssignEmps
            selectedSupplier={selectedSupplier}
            setModalFlag={setAssociate}
          />
        </CustomDrawer>

        <CustomModal
          isOpen={viewModal}
          onRequestClose={() => setViewModal(!viewModal)}
          contentComponent={
            <ViewEmps
              selectedSupplier={selectedSupplier}
              setModalFlag={setViewModal}
            />
          }
          style={ViewModalStyles}
        />
      </div>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal flag={(!searchData && loading)} />
    </>
  );
};

export default AssociateEmps;
